export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/stock-transactions`,
        name: `${prefix}.stock-transactions.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-transactions.index`,
                PageDescription: "Inventory management: Stock Transactions",
            },
        },
    },
    
    
];
